module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event_detail_try_on_dress_02-133894475c03491fe6a6be72bba96e5f.jpg";